import { lazy, Suspense } from 'react';
import { Card } from '@bid/shared-ui';

// Use Module Federation dynamic import
// This ensures proper shared scope handling
const NPCGenerator = lazy(() => import('npcGenerator/NPCGenerator'));

export const NPCGeneratorPage = (): JSX.Element => {
  return (
    <div data-testid="npc-generator-page">
      <Suspense
        fallback={
          <Card title="Loading NPC Generator...">
            <div className="flex items-center justify-center p-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-bitd-gold"></div>
            </div>
          </Card>
        }
      >
        <NPCGenerator />
      </Suspense>
    </div>
  );
};
